import React from "react";

const config = require("../../../config.json")
const client = config.APP_CLIENT;
const compagnyColorSecondary= config.APP_COMPAGNYCOLORSECONDARY;
const PhoneLink = {
  textDecoration: "none",
  color: compagnyColorSecondary,
  lineHeight: "0",
  fontSize: "12px",
  lineHeight: "normal",
  fontWeight: "700",
  margin: "0"
};

function telWithoutSpaces(number) {
  return number.replace(/\s/g, "");
}

export default function Phone(phone) {
  return (
    <a href={`tel:${telWithoutSpaces(phone.phone)}`}
      style={PhoneLink}
      >
      {phone.phone}
    </a>
  );
}
